import { render, staticRenderFns } from "./message-recharge.vue?vue&type=template&id=e3663620&"
import script from "./message-recharge.vue?vue&type=script&lang=js&"
export * from "./message-recharge.vue?vue&type=script&lang=js&"
import style0 from "./message-recharge.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports